import { Heading3 } from '@blueprint/heading';
import { Icon, Text } from '@blueprint/ui';
import { FC, Fragment } from 'react';
import {
    IconAndHeadingWrapper,
    LinkWrapper,
    Section,
    SectionHeading,
    SectionIcon,
    SectionWrapper,
    StyledButtonLinkWithIcon,
    StyledImage,
    StyledLink
} from './SearchSuggestionsTownsAndCities.styles';
import { Area } from './SearchSuggestionsTownsAndCities.types';
import { sectionIcon } from './sectionIcon';
import { Divider } from '@zoopla-eng/zds-components/divider';
import { Box } from '@zoopla-eng/zds-components/box';

type TownsAndCitiesLinksProps = {
    areas: Area[];
    trackSeeAll: () => void;
    trackSeeIndividual: (location: string) => void;
};

export const SearchSuggestionTownsAndCityLinks: FC<
    TownsAndCitiesLinksProps
> = ({ areas, trackSeeAll, trackSeeIndividual }) => {
    return (
        <Fragment>
            {areas.map((area, index) => {
                return (
                    <Fragment key={area.id}>
                        <SectionWrapper data-testid="town-and-city-link-group">
                            <SectionHeading>
                                <SectionIcon>
                                    <StyledImage
                                        src={sectionIcon(area.id)}
                                        alt=""
                                        loading="lazy"
                                    />
                                </SectionIcon>
                                <IconAndHeadingWrapper>
                                    <Heading3 size="5">
                                        {area.headline}
                                    </Heading3>
                                    <Text size="8">{area.sub_headline}</Text>
                                    {area.see_all_property && (
                                        <StyledLink
                                            data-testid="towns-and-city-links-see-all"
                                            href={area.see_all_property.link}
                                            variant="tertiary"
                                            onClick={trackSeeAll}
                                        >
                                            {area.see_all_property.text}
                                        </StyledLink>
                                    )}
                                </IconAndHeadingWrapper>
                            </SectionHeading>
                            <Section>
                                {area.items.slice(0, 3).map((item) => {
                                    return (
                                        <Fragment key={item.url}>
                                            <LinkWrapper>
                                                <StyledButtonLinkWithIcon
                                                    variant="tertiary"
                                                    href={item.url}
                                                    data-testid="town-and-city-link"
                                                    onClick={() =>
                                                        trackSeeIndividual(
                                                            item.location
                                                        )
                                                    }
                                                >
                                                    <Icon
                                                        iconId="arrow_full_right"
                                                        size="small"
                                                    />
                                                    {item.headline}
                                                </StyledButtonLinkWithIcon>
                                            </LinkWrapper>
                                        </Fragment>
                                    );
                                })}
                            </Section>
                            <Section>
                                {area.items.slice(3, 6).map((item) => {
                                    return (
                                        <Fragment key={item.url}>
                                            <LinkWrapper>
                                                <StyledButtonLinkWithIcon
                                                    variant="tertiary"
                                                    href={item.url}
                                                    onClick={() =>
                                                        trackSeeIndividual(
                                                            item.location
                                                        )
                                                    }
                                                >
                                                    <Icon
                                                        iconId="arrow_full_right"
                                                        size="small"
                                                    />
                                                    {item.headline}
                                                </StyledButtonLinkWithIcon>
                                            </LinkWrapper>
                                        </Fragment>
                                    );
                                })}
                            </Section>
                        </SectionWrapper>
                        {index < areas.length - 1 && (
                            <Box pt="$M300" pb="$M300">
                                <Divider direction="horizontal" />
                            </Box>
                        )}
                    </Fragment>
                );
            })}
        </Fragment>
    );
};
